import { FC, useContext } from 'react';
import classNames from 'classnames';
import { AccordionContext, useAccordionToggle } from 'react-bootstrap';

import { CommonIconProps } from 'src/components/Icons/commonIconProps';
import { IconChevronUp } from 'src/components/Icons/ChevronUp';
import { ItemButton } from './Button';
import styles from './styles.module.scss';

type Props = {
  title: string;
  icon: FC<CommonIconProps>;

  testId?: string;
};

type ToggleProps = Pick<Props, 'title' | 'icon' | 'testId'> & {
  eventKey: string;
};

export const ItemAccordionToggle: FC<ToggleProps> = ({ title, icon, testId, eventKey }) => {
  const currentEventKey = useContext(AccordionContext);

  const decoratedOnClick = useAccordionToggle(eventKey);

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <ItemButton
      title={title}
      icon={icon}
      testId={testId}
      onClick={decoratedOnClick}
      suffix={<IconChevronUp className={classNames(styles.iconToggle, isCurrentEventKey && styles.rotated)} />}
    />
  );
};
